import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { disabledTabMoveButton, disabledTabMoveInput, fallbackTabMove} from 'helper/index';

const ExitModal = () => {
  const closeBtnRef = useRef(null);
  const dispatch = useDispatch();
  const closeModal = () => {
    dispatch(disableAllMenu());
    fallbackTabMove();
    document.querySelector('._header_close').focus();
  };
  
  useEffect(() => {
    disabledTabMoveButton(['exit_btn','ri-close-line exit']);
    disabledTabMoveInput();
  }, []);

  return (
    <div className="exit_bg">
      <div className="modal_area">
      <button  type='button' className="ri-close-line exit" onClick={closeModal} aria-label='닫기'/>
        <div className="alert_box">챗봇이 종료됩니다.</div>
        <button
          type='button'
          className="exit_btn"
          onClick={() => {
            dispatch(disableAllMenu());
            fallbackTabMove();
            window.close();
          }}
        >
          확인
        </button>
      </div>
    </div>
  );
};

export default ExitModal;
